const questions = [
    {
      question: "What is the capital of France?",
      options: ["Paris", "London", "Berlin", "Madrid"],
      answer: "Paris"
    },
    {
      question: "What is the largest country in Africa?",
      options: ["Morroco", "Egypt", "Algeria", "South Africa"],
      answer: "Algeria"
    },
    {
      question: "Where is the Okavango Delta located?",
      options: ["Botswana", "United States", "Thailand", "Serbia"],
      answer: "Botswana"
    },
  ];
  
  export default questions;